export class Confirmation {
  public PlanName: string;
  public EffectiveDate: Date;
  public ReferenceNumber: string;
  public Address: string;
  public Name: string;
  public PaymentFrequency: string;
  public Rate: string;
  public UnderwritingStatus: number;
  public PreneedProgramType: string;
  public DateOfBirth: string;
}